export type CalendarService = 'google' | 'microsoft';

export interface ConnectedCalendar {
  email: string;
  service: CalendarService;
}

export const AGENT_CALENDAR_PREFERENCE_KEYS = ['scheduling_recruiter_email', 'calendar_recruiter_email'] as const;

export function agentPreferenceDocId(uid: string, key: string): string {
  return `${uid}__${key}`;
}

const normalizeEmail = (email: unknown): string => (typeof email === 'string' ? email.trim().toLowerCase() : '');

export function calendarServiceOf(member: any): CalendarService | null {
  if (member?.googleAccessToken && member?.googleRefreshToken) return 'google';
  if (member?.microsoftAccessToken && member?.microsoftRefreshToken) return 'microsoft';
  return null;
}

function isOwnedBy(member: any, service: CalendarService, login: string): boolean {
  if (normalizeEmail(member?.email) === login) return true;
  const connectedBy = member?.createdFromUser?.[service];
  return Array.isArray(connectedBy) && connectedBy.some((email) => normalizeEmail(email) === login);
}

export function pickOwnCalendar(members: any[], loginEmail: string): ConnectedCalendar | null {
  const login = normalizeEmail(loginEmail);
  if (!login) return null;
  const own = (members || []).filter((m) => {
    const service = calendarServiceOf(m);
    return !!service && !!m?.email && isOwnedBy(m, service, login);
  });
  const best = own.find((m) => normalizeEmail(m.email) === login) || own[0];
  return best ? { email: best.email, service: calendarServiceOf(best) } : null;
}

export function preferenceNeedsUpdate(currentValue: unknown, members: any[], calendar: ConnectedCalendar): boolean {
  if (typeof currentValue !== 'string' || !currentValue) return true;
  if (currentValue === calendar.email) return false;
  return !(members || []).some((m) => m?.email === currentValue && calendarServiceOf(m));
}
